import { indexTopics } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">漫画索引</h2>
          <span className="text-xs text-foreground-500 mt-1 whitespace-nowrap">韩漫大全分类</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexTopics.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="flex items-start gap-4 p-5 rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 text-lg group-hover:bg-accent-200 transition-colors shrink-0">
                <i className={topic.icon}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">{topic.title}</h3>
                <p className="text-xs text-foreground-500 mt-1">{topic.desc}</p>
                <span className="inline-block mt-2 text-xs text-foreground-400">{topic.count} 部作品</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}